import type { IEvent } from "../../interfaces/event";
import { mapUnassignedJobs } from "./unassignedJobsMapper";
import { normalizeUnassignedJob } from "./normalizeUnassignedJob";

/**
 * Maps and returns unassigned jobs for AIEmpower context.
 */
export function logAIEmpowerUnassignedJobs(unassignedJobs: IEvent[]) {
  const normalized = (unassignedJobs ?? []).map(normalizeUnassignedJob);
  const mapped = mapUnassignedJobs(normalized);
  return mapped;
}
